import React from "react";

import "./about.css";

const About = () => {
  return (
    <section id="about">
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="container about__content">
          <p>
            Hi, I am Tom. Full-stack developer, systems thinker, and yes I do
            have 47 browser tabs open. No I will not close them.
          </p>
          <p>
            I did not take the traditional route into this. No CS degree, no "I
            knew I wanted to code since I was 5" origin story. I did a bootcamp
            for less than 3 months, got thrown into the deep end, and figured
            out pretty quickly that it is either sink or swim. I am still here
            so I guess that says something.
          </p>
          <p>
            That was 4 years ago. Still learning, still building, still
            occasionally breaking things in production. Not on purpose. Well,
            not always. Happens to the best of us and I refuse to believe
            otherwise
          </p>
          <p>
            What actually keeps me hooked is the architecture side. I am less
            interested in just making things work and more interested in why
            they work, what happens when they do not, and how to make sure they
            hold up when things get weird. Long term I want to be the person who
            designs and deploys AI-powered systems end to end. Getting there,
            one rabbit hole at a time.
          </p>
          <p>
            I have worked across the full stack, from UIs to APIs, real-time
            voice pipelines, AI integrations, and cloud infrastructure. I think
            in systems, not just features. And I ask a lot of "but what happens
            when" questions that my teammates either appreciate or find mildly
            annoying. Probably both.
          </p>
          <p>
            Want to collab, talk tech, or just send me an interesting problem at
            2am? Genuinely open to it. I am the kind of person who enjoys a good
            engineering conversation almost as much as a good cup of coffee.
            Almost.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
